import * as angular from "angular";
import { ToastUtils } from "../../helper/toast.helper";

let AuthLoginComponent = {
    selector: "vcAuthLogin",
    templateUrl: "/angular/components/login/auth-login.component.html",
    bindings: {
        authenticate: "=?",
        cancelFn: "&?",
        successFn: "&?",
    },
    controller: class AuthLoginController {
        // * bindings for typescript compiler *
        public authenticate?: any;
        public cancelFn?: any;
        public successFn?: any;
        // ************************************

        private readonly $scope: any;
        private readonly __time_zone: string;

        private toast: ToastUtils;
        private __env: any;
        private $http: any;

        public loading = false;
        public showCancel: boolean;
        public authenticate_error: string | null = null;
        public login: any;

        constructor(
            $scope: any,
            __env: any,
            $http: any,
            __time_zone: string,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.$http = $http;
            this.__env = __env;
            this.__time_zone = __time_zone;
            this.toast = ToastUtils;
        }

        $onInit() {
            this.showCancel = !!this.cancelFn;
            this.authenticate = this.authenticate || {};
            this.login = {
                email: this.authenticate.email,
                phonenumber: this.authenticate.phonenumber,
                countrycode: this.authenticate.countrycode,
                code: null,
                region: this.authenticate.region,
                key: this.authenticate.key,
            };

            this.$scope.$watch(
                () => this.login.code,
                (newValue: string | null, oldValue: string | null) => {
                    if (newValue !== oldValue && newValue.length == 6) {
                        this.sendAuthenticationForm();
                    }
                },
                true
            );
        }

        sendAuthenticationForm(region?: string): void {
            this.authenticate_error = null;
            this.loading = true;

            let url = "";
            if (angular.isDefined(region)) {
                url =
                    "https://" +
                    region +
                    "." +
                    this.__env.host +
                    this.__env.apiUrl() +
                    "/login/authenticate?timezone=" +
                    encodeURIComponent(this.__time_zone);
            } else {
                url =
                    this.__env.apiUrl() +
                    "/login/authenticate?timezone=" +
                    encodeURIComponent(this.__time_zone);
            }

            this.$http.post(url, this.login).then(
                (response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        this.successFn({ response: response, region: region });
                    } else if (angular.isDefined(json.region)) {
                        this.sendAuthenticationForm(json.region);
                    } else {
                        this.authenticate_error = json.message;
                        this.authenticate.code = "";
                        this.loading = false;
                    }
                },
                () => {
                    this.loading = false;
                    this.authenticate.code = "";
                    this.authenticate_error = "An error has occurred";
                }
            );
        }

        cancelAuthentication(): void {
            this.authenticate = null;
            this.authenticate_error = null;
            this.loading = false;
            this.cancelFn();
        }

        copyCode(text: string): void {
            let copyElement = document.createElement("textarea");
            copyElement.style.position = "fixed";
            copyElement.style.opacity = "0";
            copyElement.textContent = text;
            let body = document.getElementsByTagName("body")[0];
            body.appendChild(copyElement);
            copyElement.select();
            document.execCommand("copy");
            body.removeChild(copyElement);
            this.toast.success("Code copied");
        }
    },
};

angular
    .module("login")
    .component(AuthLoginComponent.selector, AuthLoginComponent);
